import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import WhyAIAutomation from '../../Components/Automation/WhyAIAutomation'
import IndustriesWeServe from '../../Components/Automation/IndustriesWeServe'
import { ArrowRight, CheckCircle, Circle } from 'lucide-react'

import { Helmet } from "react-helmet-async";
const featuresData = [
    {
        id: 1,
        title: "Honeywell",
        description:
            "Smart, reliable DDC Spyder Controllers for everyday comfort",
        image: "/assets/v/item1.png",
    },
    {
        id: 2,
        title: "Niagara Framework",
        description:
            "Simplifying WEBStation-AX & Niagara N4 for You",
        image: "/assets/v/item2.png",
    },
    {
        id: 3,
        title: "Johnson Controls",
        description:
            "Smart NAE Supervisors & FECs for reliable, easy control",
        image: "/assets/v/item3.png",
    },
    {
        id: 4,
        title: "Alerton",
        description:
            "Simple Compass Guidance with an Easy DDC Bar",
        image: "/assets/v/item4.png",
    },
    {
        id: 5,
        title: "Indusfot",
        description:
            "Simple, reliable SCADA systems that keep your operations running smoothly.",
        image: "/assets/v/item5.png",
    },
    {
        id: 6,
        title: "Mitsubishi",
        description:
            "Reliable FX Series PLCs, A Series PLCs, and Q Series PLCs for smarter automation",
        image: "/assets/v/item6.png",
    },
    {
        id: 7,
        title: "Distech Controls",
        description:
            "Smart controllers that make buildings easier to manage",
        image: "/assets/v/item7.jpg",
    },
    {
        id: 8,
        title: "Siemens",
        description:
            "Reliable SIMATIC S7-1200, KTP HMI & TIA Portal solutions",
        image: "/assets/v/item8.jpg",
    },
];

const whyMobikodePoints = [
    "We have hands-on experience working with both open and proprietary BMS platforms",
    "Successfully delivered multiple BMS upgrades and smooth system migrations",
    "Focus on creating energy-efficient, scalable, and future-ready solutions",
    "We handle everything end-to-end from design to commissioning and ongoing support",
];
const approachData = [
    {
        id: 1,
        step: "01",
        title: "Hardware Design & Engineering for BMS",
        desc: [
            "We design reliable automation systems, from architecture to hardware setup",
            "Create detailed and easy-to-understand engineering documentation",
            "Prepare accurate, OEM-specific Bills of Materials (BOM)",
            "Support panel engineering and smooth system integration",
            "Perform thorough hardware testing to ensure quality and performance",
            "Handle FAT, SAT, commissioning, and on-site testing for seamless deployment",
        ],
    },
    {
        id: 2,
        step: "02",
        title: "Software Design & Engineering for BMS",
        desc: [
            "We create clear and practical functional designs with proper documentation",
            "Develop and configure BMS applications tailored to your needs",
            "Design user-friendly dashboards, graphics, and HMI with complete testing",
            "Integrate third-party systems for seamless building operations",
            "Handle database migration and reverse engineering efficiently",
            "Upgrade and migrate applications to the latest BMS platforms",
            "Ensure smooth testing, commissioning, and system handover",
        ],
    },
    {
        id: 3,
        step: "03",
        title: "System Migration & Modernization Services",
        desc: [
            "Smooth upgrades from Niagara AX WebStation-AX to Niagara N4",
            "Seamless migration of Johnson Controls systems to the Niagara Framework",
            "Transformation of legacy BMS into modern, efficient platforms",
            "Conversion of pneumatic systems into smart electronic BMS solutions",
            "Modernizing outdated systems with open protocols for better performance and long-term reliability",
        ],
    },
    {
        id: 4,
        step: "04",
        title: "On-Site & Lifecycle BMS Services",
        desc: [
            "Regular Annual Preventive Maintenance (APM) to keep your systems running smoothly",
            "Quick and reliable troubleshooting for Building Management Systems",
            "Hassle-free site commissioning with proper Site Acceptance Testing (SAT)",
            "Smooth upgrade and migration support with minimal disruption to your operations",
        ],
    },
];
function BMSSolutions() {
    return (
        <div>
<Helmet>
    <title>
        Building Automation Solutions & BMS Services | Mobikode
    </title>

    <meta
        name="description"
        content="Transform buildings with Mobikode's Building Automation and BMS Services. Get BMS design, engineering, system integration, migration, modernization, commissioning, maintenance, and lifecycle support."
    />

    <meta
        name="keywords"
        content="Building Automation Solutions, Building Automation Services, Building Management System, BMS Services, BMS Solutions, Building Automation System, BMS Engineering Services, BMS Design Services, BMS Integration, BMS Migration, BMS Modernization, BMS Commissioning, BMS Maintenance Services, Building Control Systems, Smart Building Solutions, Building Automation Company, Building Management Solutions"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/building-automation"
    />

    <meta
        property="og:title"
        content="Building Automation Solutions & BMS Services | Mobikode"
    />

    <meta
        property="og:description"
        content="Mobikode delivers end-to-end Building Automation and BMS solutions covering system design, engineering, integration, migration, modernization, testing, commissioning, and ongoing support."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/building-automation"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/service-detail/img18.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Building Automation Solutions & BMS Services | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Improve building efficiency, comfort, security, and centralized control with Mobikode's Building Automation and BMS expertise."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/service-detail/img18.png"
    />
</Helmet>
            <AiHero title="Building Automation Solutions & Services (BMS)" imgData="/assets/service-detail/img18.png" />
            <section className="w-full pt-16 lg:pt-[100px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[15px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row lg:items-center group lg:h-[507px]">
                        <div className="relative lg:absolute top-0 right-0 w-full lg:max-w-[656px] h-[250px] md:h-[350px] lg:h-full bg-gray-100 overflow-hidden">
                            <img
                                src="/assets/v/item10.png"
                                alt="ai automation"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>
                        <div className="relative z-20 w-[92%] sm:w-[85%] lg:w-full max-w-[719px] mx-auto lg:mx-0 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] px-[20px] py-[30px] lg:px-[60px] lg:py-[80px] -mt-[40px] lg:mt-0">
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">
                                We provide complete Building Automation and BMS solutions that make buildings smarter, safer, and more efficient. From designing field devices to setting up centralized monitoring and control systems, we handle everything end-to-end. At Mobikode, we also support upgrades, testing, and modernization of existing systems helping commercial and industrial spaces run smoothly, save energy, and improve comfort for everyone inside.
                            </p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>
                        </div>
                    </div>
                </div>
            </section>
            <WhyAIAutomation title="BMS Platforms & Technology Expertise" fData={featuresData} />
            {/* <TechServicesSection title="Explore Our Services" sData={services} /> */}
            {/* <IndustriesWeServe /> */}
            <section className="w-full bg-[#FDFDFD] pb-16 lg:pb-24 relative overflow-hidden">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                    {/* <div className="mb-[30px] lg:mb-[60px]">
                        <h2 className="text-[#01386A] font-sora text-[22px] lg:text-[32px] font-[600] text-left">
                            Our Approach
                        </h2>
                        <p className="text-[#49577A] mt-2 text-left font-graphik text-[16px]">
                            A structured path from raw data to business optimization.
                        </p>
                    </div> */}

                    {/* Grid for Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
                        {approachData.map((item) => (
                            <div
                                key={item.id}
                                className="relative bg-[#F0F0F0] p-8 min-h-[180px] flex flex-col justify-start overflow-hidden group transition-all duration-300 hover:shadow-lg hover:-translate-y-1 rounded-sm"
                            >
                                <div className="relative z-10">
                                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-2 leading-tight">
                                        {item.title}
                                    </h3>
                                    <div className='grid gap-[8px]'>
                                        {item?.desc.map((e, i) => {
                                            return (
                                                <div className='flex items-center gap-[10px]'>
                                                    <Circle size={6} className="text-[#F06115] fill-[#F06115]/10" />
                                                    <p key={i} className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-snug">
                                                        {e}
                                                    </p>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                                <div
                                    className="absolute bottom-0 right-0 w-[180px] h-[140px] pointer-events-none transition-transform duration-500 group-hover:scale-110 opacity-50 lg:opacity-100"
                                >
                                    <img src="/assets/career/wrap1.svg" alt="" className="w-full h-full object-contain object-bottom-right" />
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </section>

            <section className="w-full bg-white pb-16 lg:pb-24 relative overflow-hidden">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                    <div className="bg-[#F9F9F9] p-6 lg:p-12 border border-gray-100 flex flex-col lg:flex-row items-stretch gap-10 lg:gap-16">

                        <div className="w-full lg:w-3/5 flex flex-col justify-center">
                            <div className="text-left mb-8">
                                <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] mb-4">
                                    Why Choose Us for Building Automation?
                                </h2>
                                <div className="w-20 h-1 bg-[#F06115]"></div>
                            </div>

                            <div className="grid grid-cols-1 gap-2 pb-[24px]">
                                {whyMobikodePoints.map((point, index) => (
                                    <div key={index} className="flex items-start gap-3 group">
                                        <div className="mt-1 flex-shrink-0">
                                            <CheckCircle size={20} className="text-[#F06115] fill-[#F06115]/10" />
                                        </div>
                                        <p className="text-[#01386A] font-graphik text-[14px] lg:text-[16px] font-[500] leading-relaxed group-hover:text-[#F06115] transition-colors duration-300">
                                            {point}
                                        </p>
                                    </div>
                                ))}
                            </div>

                            <p className="text-[#49577A] font-graphik font-[500] text-[14px] lg:text-[16px]">
                                Partner with us for reliable, scalable automation that helps your business run smoother and grow confidently.
                            </p>
                        </div>

                        <div className="w-full lg:w-2/5 flex">
                            <div className="relative w-full h-full min-h-[300px]">
                                <img
                                    src="/assets/what/img6.png"
                                    alt="Building Automation Services"
                                    className="w-full h-full object-cover shadow-lg"
                                />
                                <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-[#F06115]/10 -z-10"></div>
                                <div className="absolute -top-4 -right-4 w-12 h-12 bg-[#01386A]/5 -z-10"></div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <section className="relative w-full h-[400px] lg:h-[507px] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/career/img12.png"
                        alt="Building Automation (BMS) Background"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/10"></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] lg:px-[80px] h-full flex items-center lg:items-center ">
                    <div className="bg-white p-8 lg:p-12 max-w-[640px] shadow-2xl rounded-sm">

                        <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora leading-tight mb-6">
                            Building Automation Solutions & Services (BMS)
                        </h2>
                        <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] leading-[24px] font-graphik mb-8">
                            Making buildings smarter with intelligent BMS solutions that improve energy use,
                            enhance security, and create more comfortable spaces through simple, centralized control.
                        </p>
                        <a href="/contact" className="inline-flex items-center gap-2 text-[#01386A] underline font-graphik font-[500] text-[14px] lg:text-[16px] hover:gap-3 transition-all duration-300 group">
                            Contact Now
                            <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" />
                        </a>

                    </div>
                </div>
            </section>
        </div>
    )
}

export default BMSSolutions
